import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { useI18n, STR } from "../i18n";
import { COMPANY } from "../mock";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="footer">
      <div className="container-x">
        <div className="grid">
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <div style={{ width: 44, height: 44, borderRadius: 8, background: "var(--gold)", display: "grid", placeItems: "center", color: "var(--navy)", fontFamily: "Barlow Condensed", fontWeight: 800, fontSize: 22 }}>GA</div>
              <div>
                <div style={{ color: "#fff", fontFamily: "Barlow Condensed", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase" }}>Grupo Inversiones</div>
                <div style={{ color: "var(--gold)", fontFamily: "Barlow Condensed", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", fontSize: 20, lineHeight: 1 }}>Altamira</div>
              </div>
            </div>
            <p style={{ fontSize: 14, lineHeight: 1.7, color: "#a9b3c4", maxWidth: 340 }}>
              {t({
                es: "Suministro industrial y petrolero con operaciones en Venezuela, Colombia y Estados Unidos.",
                en: "Industrial and oilfield supply with operations in Venezuela, Colombia and the United States.",
              })}
            </p>
          </div>
          <div>
            <h4>{t(STR.nav.company)}</h4>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: 2 }}>
              <li><Link to="/empresa">{t({ es: "Sobre nosotros", en: "About us" })}</Link></li>
              <li><Link to="/servicios">{t(STR.nav.services)}</Link></li>
              <li><Link to="/catalogo">{t(STR.nav.catalog)}</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contacto">{t(STR.nav.contact)}</Link></li>
            </ul>
          </div>
          <div>
            <h4>{t({ es: "Contacto", en: "Contact" })}</h4>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: 1.9, fontSize: 14 }}>
              <li><MapPin size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "-2px" }} />{COMPANY.addresses[1].text}</li>
              <li style={{ marginTop: 4 }}><MapPin size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "-2px" }} />{COMPANY.addresses[0].text}</li>
              <li style={{ marginTop: 4 }}><MapPin size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "-2px" }} />{COMPANY.addresses[2].text}</li>
              <li><Mail size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "-2px" }} /><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
              {COMPANY.phones.map(p => (
                <li key={p.wa}><Phone size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "-2px" }} />[{p.flag}] <a href={`tel:${p.tel}`}>{p.label}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4>{t({ es: "Síganos", en: "Follow us" })}</h4>
            <div style={{ display: "flex", gap: 10 }}>
              <a href={COMPANY.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" style={socialStyle}><Instagram size={18} /></a>
              <a href={COMPANY.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" style={socialStyle}><Facebook size={18} /></a>
              <a href={COMPANY.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" style={socialStyle}><Linkedin size={18} /></a>
            </div>
          </div>
        </div>
        <div className="bottom">
          <div>© {new Date().getFullYear()} {COMPANY.name}. {t({ es: "Todos los derechos reservados.", en: "All rights reserved." })}</div>
          <div>RIF J-XXXXXXXX-X · {t({ es: "El Tigre, Venezuela", en: "El Tigre, Venezuela" })}</div>
        </div>
      </div>
    </footer>
  );
}
const socialStyle = { width: 40, height: 40, borderRadius: 8, background: "rgba(255,255,255,0.08)", display: "grid", placeItems: "center", color: "#fff" };
